import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { RigidBody } from "@react-three/rapier";

export default function TimelineTrigger({ onEnterTimeline, onExitTimeline }) {
    const playerInZone = useRef(false);
    const lastCheckTime = useRef(0);
    const triggerPosition = [-44, -5, 15];
    const triggerSize = [20, 10, 20];

    useFrame((state) => {
        // Throttle position checks every 100ms
        if (state.clock.elapsedTime - lastCheckTime.current < 0.1) return;
        lastCheckTime.current = state.clock.elapsedTime;

        // Get player position
        const playerPos = window.playerPosition;
        if (!playerPos) return;

        const inZone =
            playerPos.x >= triggerPosition[0] - triggerSize[0] / 2 &&
            playerPos.x <= triggerPosition[0] + triggerSize[0] / 2 &&
            playerPos.y >= triggerPosition[1] - triggerSize[1] / 2 &&
            playerPos.y <= triggerPosition[1] + triggerSize[1] / 2 &&
            playerPos.z >= triggerPosition[2] - triggerSize[2] / 2 &&
            playerPos.z <= triggerPosition[2] + triggerSize[2] / 2;

        // Only trigger callbacks when state actually changes
        if (inZone && !playerInZone.current) {
            playerInZone.current = true;
            onEnterTimeline();
        } else if (!inZone && playerInZone.current) {
            playerInZone.current = false;
            onExitTimeline();
        }
    });

    return (
        <RigidBody type="fixed" sensor position={triggerPosition}>
            <mesh>
                <boxGeometry args={triggerSize} />
                <meshBasicMaterial transparent opacity={0} />
            </mesh>
        </RigidBody>
    );
}